//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import * as gatewayMediaApi from '@apis/gatewayMediaApi';

(() => {
  const curalate = angular.module('curalate');

  curalate.service('LabelsApiService', [
    function () {
      /**
       * This is for backwards compatibility with legacy components, and should not be used.
       */
      this.searchLabelsAsync = gatewayMediaApi.searchLabelsDeprecated;
    },
  ]);
})();
